import { render, staticRenderFns } from "./NextMoveInterestsQuestions.vue?vue&type=template&id=a5dbca90&scoped=true"
import script from "./NextMoveInterestsQuestions.vue?vue&type=script&lang=ts"
export * from "./NextMoveInterestsQuestions.vue?vue&type=script&lang=ts"
import style0 from "./NextMoveInterestsQuestions.vue?vue&type=style&index=0&id=a5dbca90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5dbca90",
  null
  
)

export default component.exports